import { createFileRoute } from '@tanstack/react-router'
import { CloseMonthPage, type CloseSearch } from '~/features/compensation/CloseMonthPage'
import { NoFinanceAccess } from '~/features/compensation/parts'
import { closeTarget, loaderSeason, monthQuery, seasonQuery } from '~/features/compensation/queries'
import { useCan } from '~/lib/session'

const MONTH = /^\d{4}-(0[1-9]|1[0-2])$/
const UUID = /^[0-9a-f-]{36}$/i

export const Route = createFileRoute('/_app/verein/praemien/abschluss')({
  // Invalid values become undefined explicitly: an omitted key would keep the raw value (e.g. '?monat').
  validateSearch: (s: Record<string, unknown>): CloseSearch => ({
    monat: typeof s.monat === 'string' && MONTH.test(s.monat) ? s.monat : undefined,
    person: typeof s.person === 'string' && UUID.test(s.person) ? s.person : undefined,
  }),
  loaderDeps: ({ search }) => ({ monat: search.monat }),
  loader: async ({ context, deps }) => {
    const s = await loaderSeason(context.queryClient)
    if (!s?.canRead) return
    const month =
      deps.monat ??
      closeTarget(await context.queryClient.ensureQueryData(seasonQuery(s.season))) ??
      new Intl.DateTimeFormat('en-CA', { timeZone: s.timezone, year: 'numeric', month: '2-digit' }).format(new Date())
    await context.queryClient.ensureQueryData(monthQuery(month))
  },
  component: function Abschluss() {
    const search = Route.useSearch()
    return useCan()('finance.read') ? <CloseMonthPage search={search} /> : <NoFinanceAccess title="Prämien" />
  },
})
